(function(){var id='monnry-header-tablet-fix';function add(){if(document.getElementById(id))return;var s=document.createElement('style');s.id=id;s.textContent='@media screen and (min-width:641px) and (max-width:1180px){.nav-bar{display:none!important}.header__inner{display:grid!important;grid-template-columns:1fr auto 1fr!important;align-items:center!important;gap:8px!important;min-width:0!important}.header__mobile-nav,.header__mobile-nav.hidden-lap-and-up,.hidden-lap-and-up.header__mobile-nav{display:flex!important;grid-column:1!important;justify-self:start!important;align-items:center!important;min-width:0!important}.header__search-bar-wrapper{display:none!important}.header__logo{grid-column:2!important;justify-self:center!important;margin:0!important;position:static!important;left:auto!important;right:auto!important;transform:none!important;min-width:0!important}.header__logo-link{display:flex!important;align-items:center!important;justify-content:center!important}.header__logo-image{max-width:120px!important;width:auto!important;height:auto!important}.header__action-list{grid-column:3!important;justify-self:end!important;display:flex!important;align-items:center!important;justify-content:flex-end!important;gap:6px!important;margin:0!important;min-width:0!important}.header__action-item--payment{display:none!important}.header__action-item--locale{display:flex!important;align-items:center!important;margin-right:0!important}.header__action-item--locale .header__action-item-title,.header__action-item--account .header__action-item-title,.header__action-item--cart .hidden-pocket,.header__action-item--cart .hidden-lap,.header__action-item--account .hidden-pocket,.header__action-item--account .hidden-lap{display:none!important}.header__action-item--locale .header__action-item-link{padding:3px!important;gap:3px!important}.locale-selector__value{font-size:10px!important;white-space:nowrap!important}.header__action-item--locale .icon--arrow-bottom{display:none!important}.header__mobile-menu{width:min(86vw,360px)!important;max-width:360px!important;z-index:100000!important}}@media screen and (min-width:1000px) and (max-width:1180px){#lang-fab-wrapper{display:block!important}}@media screen and (min-width:1181px){.nav-bar{display:block!important}}';document.head.appendChild(s)}function h(){var e=document.querySelector('[data-section-type="header"]')||document.querySelector('.shopify-section__header');if(e)document.documentElement.style.setProperty('--header-height',e.clientHeight+'px')}function init(){add();h();window.addEventListener('resize',h,{passive:true});window.addEventListener('orientationchange',function(){setTimeout(h,250)})}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init()})();

(function(){
  var LOGIN_CONTEXT_KEY='monnry_login_context';
  var quickBuyLoginArmed=false;

  function removeQuickBuyLoginContext(){
    try{sessionStorage.removeItem(LOGIN_CONTEXT_KEY)}catch(e){}
  }

  document.addEventListener('monnry:login-context',function(event){
    if(event&&event.detail&&event.detail.context==='quick_buy'){
      quickBuyLoginArmed=true;
      setTimeout(function(){
        quickBuyLoginArmed=false;
        removeQuickBuyLoginContext();
      },800);
    }
  },true);

  document.addEventListener('click',function(event){
    var loginLink=event.target.closest('.js-monnry-login-open, a[href="#monnry-client-login"], a[href="/account/login"], a[href="/en/account/login"], a[href$="/account/login"]');
    if(loginLink&&!quickBuyLoginArmed){
      removeQuickBuyLoginContext();
    }

    if(event.target.closest('[data-mn-client-login-close]')){
      removeQuickBuyLoginContext();
    }
  },true);

  document.addEventListener('keydown',function(event){
    if(event.key==='Escape') removeQuickBuyLoginContext();
  },true);
})();

(function(){
  var CACHE_CLEARED_KEY='monnry_related_cache_v8_discount_done';

  function clearOldRelatedCacheOnce(){
    try{
      if(sessionStorage.getItem(CACHE_CLEARED_KEY)==='1') return;
      Object.keys(sessionStorage).forEach(function(key){
        if(/^rp_/.test(key)&&key.indexOf('_v7_stock')>-1){
          sessionStorage.removeItem(key);
        }
      });
      sessionStorage.setItem(CACHE_CLEARED_KEY,'1');
    }catch(e){}
  }

  function cents(value){
    if(value===null||typeof value==='undefined'||value==='') return 0;
    var number=Number(value);
    if(Number.isNaN(number)) return 0;
    return number;
  }

  function formatMoney(value){
    if(window.Shopify&&typeof Shopify.formatMoney==='function'){
      return Shopify.formatMoney(value,(window.theme&&window.theme.moneyFormat)||'${{amount}}');
    }
    return '$'+(value/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',')+' I.V.I.';
  }

  function variantHasStock(variant){
    if(!variant) return false;
    if(variant.available===false) return false;
    if(typeof variant.inventory_quantity!=='undefined'&&variant.inventory_quantity!==null){
      return Number(variant.inventory_quantity)>0;
    }
    return variant.available===true;
  }

  function getDisplayVariant(product){
    var variants=(product&&product.variants)||[];
    if(!variants.length) return null;
    var inStock=variants.filter(variantHasStock);
    if(!inStock.length) inStock=variants.filter(function(v){return v.available!==false});
    if(!inStock.length) return null;

    var sale=inStock.find(function(v){
      return cents(v.compare_at_price)>cents(v.price)&&cents(v.price)>0;
    });

    return sale||inStock[0];
  }

  function getHandleFromCard(card){
    var link=card&&card.querySelector('a[href*="/products/"], .rp-card[href*="/products/"]');
    if(!link) return '';
    var href=link.getAttribute('href')||'';
    var match=href.match(/\/products\/([^?#\/]+)/);
    return match?match[1]:'';
  }

  function updateRelatedCard(card,product){
    var variant=getDisplayVariant(product);
    if(!card||!product||!variant) return;

    card.setAttribute('data-product-id',product.id||'');
    card.setAttribute('data-product-handle',product.handle||'');

    var priceWrap=card.querySelector('.rp-price-wrap');
    var priceEl=card.querySelector('.rp-price');
    var compareEl=card.querySelector('.rp-compare');
    var imgBox=card.querySelector('.rp-img');

    if(priceWrap){
      priceWrap.classList.add('product-item__price-list','price-list');
      priceWrap.setAttribute('data-product-id',product.id||'');
      priceWrap.setAttribute('data-product-type','price');
    }

    if(priceEl){
      priceEl.setAttribute('data-product-id',product.id||'');
      priceEl.setAttribute('data-product-type','price');
      priceEl.textContent=formatMoney(cents(variant.price));
    }

    var hasDiscount=cents(variant.compare_at_price)>cents(variant.price)&&cents(variant.price)>0;
    if(hasDiscount){
      var pct=Math.round((cents(variant.compare_at_price)-cents(variant.price))*100/cents(variant.compare_at_price));
      if(!compareEl&&priceWrap){
        compareEl=document.createElement('span');
        compareEl.className='rp-compare';
        priceWrap.appendChild(compareEl);
      }
      if(compareEl){
        compareEl.textContent=formatMoney(cents(variant.compare_at_price));
        compareEl.style.display='';
      }

      var badge=card.querySelector('.rp-discount');
      if(!badge&&imgBox){
        badge=document.createElement('div');
        badge.className='rp-discount';
        badge.innerHTML='<span></span>';
        imgBox.appendChild(badge);
      }
      if(badge){
        badge.setAttribute('aria-label','-'+pct+'%');
        var span=badge.querySelector('span');
        if(span) span.textContent='-'+pct+'%';
        badge.style.display='';
      }
    }else{
      if(compareEl) compareEl.style.display='none';
      var existingBadge=card.querySelector('.rp-discount');
      if(existingBadge) existingBadge.style.display='none';
    }
  }

  function refreshSamita(){
    try{
      if(window.Samita&&Samita.Wholesale&&typeof Samita.Wholesale.initialize==='function'){
        Samita.Wholesale.initialize();
      }
    }catch(e){}
  }

  function enhanceRelatedProducts(){
    var cards=document.querySelectorAll('.section-related-products .rp-card, section[id^="section-"] .rp-card');
    if(!cards.length) return;

    cards.forEach(function(card){
      if(card.getAttribute('data-monnry-related-enhanced')==='1') return;
      var handle=getHandleFromCard(card);
      if(!handle) return;
      card.setAttribute('data-monnry-related-enhanced','1');

      var prefix=window.location.pathname.indexOf('/en/')===0?'/en':'';
      fetch(prefix+'/products/'+handle+'.js',{credentials:'same-origin',headers:{'Accept':'application/json'}})
        .then(function(response){return response.ok?response.json():null})
        .then(function(product){
          if(!product) return;
          updateRelatedCard(card,product);
          setTimeout(refreshSamita,250);
          setTimeout(refreshSamita,1000);
        })
        .catch(function(){});
    });
  }

  function init(){
    clearOldRelatedCacheOnce();
    enhanceRelatedProducts();
    setTimeout(enhanceRelatedProducts,500);
    setTimeout(enhanceRelatedProducts,1400);
    setTimeout(refreshSamita,1600);

    var observer=new MutationObserver(function(){
      enhanceRelatedProducts();
    });
    observer.observe(document.body,{childList:true,subtree:true});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();

(function(){
  function removeRelatedProductTags(){
    document.querySelectorAll('.section-related-products .rp-tags').forEach(function(tags){
      tags.remove();
    });
  }

  function init(){
    removeRelatedProductTags();
    setTimeout(removeRelatedProductTags,300);
    setTimeout(removeRelatedProductTags,900);
    setTimeout(removeRelatedProductTags,1600);

    var observer=new MutationObserver(removeRelatedProductTags);
    observer.observe(document.body,{childList:true,subtree:true});
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();